import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, Stack, Typography } from "@mui/material";
import Icon from "@shared/components/Icon";
import React from "react";
const OfferPresentationCard = (props) => {
    const { id, title, titleComplement, surtitle, titleFeatures, features, plusFeature, plusFeatureIcon, featuresOptional, barColor, isPriceCard, } = props;
    const isPrice = isPriceCard === true || isPriceCard === "true";
    return (_jsx(Box, { sx: {
            "@media (min-width:1200px)": {
                width: "400px",
            },
            "@media (min-width:1440px)": {
                width: "480px",
            },
            maxWidth: "480px",
            flexShrink: 0,
            display: { xs: "none", lg: "block" },
            backgroundColor: "background.paper",
            position: "relative",
            boxSizing: "border-box",
            p: "32px",
            "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "6px",
                backgroundColor: barColor || "#0CFFC6",
                zIndex: 2,
            },
        }, children: _jsxs(Stack, { spacing: 2.5, children: [(surtitle || title) && (_jsxs(Stack, { spacing: 1, children: [surtitle && (_jsx(Typography, { variant: "subtitle2", component: "p", sx: {
                                color: "text.secondary",
                                fontSize: 14,
                                fontWeight: 400,
                            }, children: surtitle })), title && (_jsxs(Typography, { variant: isPrice ? "h1" : "h5", component: "h2", sx: {
                                color: "text.primary",
                                fontWeight: isPrice ? 700 : 600,
                            }, children: [title, titleComplement && (_jsx(Typography, { variant: "body1", component: "span", sx: {
                                        color: "text.secondary",
                                        fontWeight: 500,
                                        marginLeft: "12px",
                                    }, children: titleComplement }))] }))] })), (titleFeatures || features) && (_jsxs(Stack, { spacing: 1.5, children: [titleFeatures && (_jsx(Typography, { variant: "body2", sx: {
                                color: "text.secondary",
                            }, children: titleFeatures })), features && (_jsx(Box, { sx: {
                                width: "100%",
                                "& ul": {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "12px",
                                    margin: 0,
                                },
                                "& li": {
                                    color: "text.primary",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                    marginBottom: "0px !important",
                                },
                                "& ul li::before": featuresOptional
                                    ? {
                                        backgroundColor: "transparent !important",
                                        border: `2px solid ${barColor || "#0000FF"} !important`,
                                        boxSizing: "border-box",
                                    }
                                    : {
                                        backgroundColor: `${barColor || "#0000FF"} !important`,
                                    },
                            }, children: features }))] })), plusFeature && (_jsxs(_Fragment, { children: [_jsx(Divider, { sx: { backgroundColor: "border.default" } }), _jsxs(Stack, { direction: "row", spacing: 1.5, sx: { alignItems: "center" }, children: [plusFeatureIcon?.icon && (_jsx(Icon, { ...plusFeatureIcon, style: {
                                        fontSize: "16px",
                                        minWidth: "18px",
                                        minHeight: "18px",
                                    } })), _jsx(Typography, { variant: "body2", sx: { color: "text.secondary" }, children: plusFeature })] })] }))] }) }, id));
};
export default OfferPresentationCard;
